import React, { useState } from 'react';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import StepToStepCommon from 'components/common/StepComponent/StepToStep/StepToStepCommon';
import { ConfirmationModal, StickyToolbarWrapper, ToolbarForLayoutTwoCol } from 'components/common';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { LayoutTwoColComponentProps } from 'types';

const LayoutTwoColComponent: React.FC<LayoutTwoColComponentProps> = ({
  currentStep,
  steps,
  left,
  right,
  onNextStep,
  onPrevStep,
  onSaveDraft,
  form,
  isPurchase = false,
  createOrderSupplier,
  isLoading = false,
  showStep = true,
  showToolbar = true,
  classname = '',
  rightClassName = '',
  leftClassName = '',
  isDisplayCreating = true,
  confirmButton = false,
  confirmButtonLabel = 'Xác nhận',
  onConfirm,
  navigateLink = '/management/inventory/supplier-orders',
  customButton,
  cancelButton = true,
  statusLabel,
  statusColor,
  stickyTop = 56,
}) => {
  const [isOpenModel, setIsOpenModel] = useState<boolean>(false);
  const navigate = useNavigate();
  return (
    <Layout className='relative'>
      <Content className='flex flex-col py-4 px-6 bg-[var(--bgGreyEy)] '>
        {showToolbar && (
          <StickyToolbarWrapper stickyTop={stickyTop}>
            <ToolbarForLayoutTwoCol
              form={form}
              isLoading={isLoading}
              handleNextStep={onNextStep}
              handlePrevStep={onPrevStep}
              currentStep={currentStep ?? 0}
              listVersion={[]}
              setIsActive={() => {}}
              onSaveDraft={onSaveDraft}
              barcode=''
              onCancel={cancelButton ? () => setIsOpenModel(true) : undefined}
              isDisplayCreating={isDisplayCreating}
              confirmButton={confirmButton}
              confirmButtonLabel={confirmButtonLabel}
              onConfirm={onConfirm}
              customButton={customButton}
              statusLabel={statusLabel}
              statusColor={statusColor}
              createOrderSupplier={createOrderSupplier}
              isPurchase={isPurchase}
            />
            <ConfirmationModal
              isOpen={isOpenModel}
              onCancel={() => setIsOpenModel(false)}
              onConfirm={() => {
                setIsOpenModel(false);
                navigate(navigateLink);
              }}
              title='Thông tin chưa được lưu'
              subtitle={<div>Thông tin sẽ bị mất!</div>}
              icon='warning'
              confirmText='Đồng ý'
              isPurchase={isPurchase}
              onSaveDraft={onSaveDraft}
              createOrderSupplierderSupplier={createOrderSupplier}
            />
          </StickyToolbarWrapper>
        )}
        {showStep && (
          <StickyToolbarWrapper stickyTop={stickyTop + 58}>
            <StepToStepCommon current={currentStep ?? 0} steps={steps ?? []} className=' bg-[var(--bgGreyEy)] z-10 ' />
          </StickyToolbarWrapper>
        )}
        <motion.div
          className={`flex justify-center gap-[12px] w-full ${classname}`}
          layout
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        >
          <AnimatePresence mode='wait'>
            <motion.div
              key={currentStep}
              className={`flex-1 ${leftClassName}`}
              layout
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
              {left}
            </motion.div>
          </AnimatePresence>

          <AnimatePresence mode='wait'>
            <motion.div
              key={currentStep}
              className={`overflow-visible max-w-[444px] ${rightClassName}`}
              layout
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5, ease: 'easeInOut' }}
            >
              {right}
            </motion.div>
          </AnimatePresence>
        </motion.div>
      </Content>
    </Layout>
  );
};

export default LayoutTwoColComponent;
